export { Trustbar2 } from './Trustbar';
